const toggler = document.getElementById('language-toggler');
const dropdown = document.getElementById('language-dropdown');
const overlay = document.getElementById('dropdown-overlay');

if (dropdown && toggler) {
    const handleClose = () => {
        dropdown.classList.remove("show");
        if (overlay && window.innerWidth < 768) {
            overlay.classList.remove("show");
        }
        toggler.setAttribute('aria-expanded', 'false');
        document.body.removeEventListener('click', handleClose);
    };

    toggler.addEventListener('click', (e) => {
        e.stopPropagation();
        if (document.documentElement.getAttribute("dir") === "rtl") {
            dropdown.classList.replace('dropdown-menu-right', 'dropdown-menu-left');
        }
        const isExpanded = toggler.getAttribute('aria-expanded') === 'true';
        const newExpanded = !isExpanded;

        toggler.setAttribute('aria-expanded', newExpanded);
        dropdown.classList.toggle("show", newExpanded);
        if (overlay && window.innerWidth < 768) {
            overlay.classList.toggle("show", newExpanded);
        }
        if (newExpanded) {
            document.body.addEventListener('click', handleClose);
        }
    });

    dropdown.addEventListener('click', (e) => {
        e.stopPropagation();
    });

    if (overlay) {
        overlay.addEventListener('click', handleClose);
    }
}
